module.exports = __webpack_public_path__ + "static/media/programming-svgrepo-com (3).0244c329.svg";